import React from 'react';
import {useQuery} from '@apollo/react-hooks';

import TCSPopularDestinations from './TCSPopularDestinations';
import popularDestinationsQuery from './graphql/popularDestinationsQuery';
import {getQueryVariables, getPopularDestinationsData} from './helpers';
import {pushNoImageDataEvent} from './events';

export const mergeArrayObjects = (popularDestinations = [], imageData) => {
    if (popularDestinations.length > 0) {
        return popularDestinations.map((item) => {
            let data;
            const filteredImageData = imageData.filter(
                (destination) => destination.name === item.heading
            );
            const isValidUrl = filteredImageData[0]?.content.image.info[0].url?.startsWith(
                'http'
            );
            if (isValidUrl) {
                const imageUrl =
                    filteredImageData[0]?.content.image.info[0].url;
                data = {...item, imageUrl};
            } else {
                pushNoImageDataEvent(item.lbsId);
            }
            return data;
        });
    }
    return [];
};

const PopularDestinationsDataLoader = ({
    isMobile,
    showMapComponent,
    destinations: popularDestinations,
    title,
}) => {
    const lbsIds = popularDestinations?.map((destination) => destination.lbsId);
    const variables = getQueryVariables(lbsIds);
    const {loading, data, error} = useQuery(popularDestinationsQuery, {
        variables,
        ssr: false,
        errorPolicy: 'all',
    });

    if (loading || !data || !data.destinationImage) {
        return null;
    }

    if (error) {
        return error;
    }

    const imageData = getPopularDestinationsData(data);
    if (!imageData) return null;

    const destinations = mergeArrayObjects(
        popularDestinations,
        imageData
    ).filter((item) => item);

    return (
        <TCSPopularDestinations
            isMobile={isMobile}
            showMapComponent={showMapComponent}
            title={title}
            destinations={destinations}
        />
    );
};

export default PopularDestinationsDataLoader;
